import React, { FunctionComponent } from 'react';
import { hooks, Card, CardContent, Link, Skeleton } from '@bitrise/bitkit';
import { SessionAttributes } from '@trace/types';

import { ATTRIBUTES_CRASH_ORDER } from '../../../../constants/Attributes';
import { formatterTimestamp } from '../../../../utils/getFormattedAttributeValue';
import AttributeStatGrid from '../../../AttributeStat/AttributeStatGrid';
import useFeatures from '../../../Features/useFeatures';

interface Props {
  attributes?: SessionAttributes;
  crashTimestamp?: string;
  isFetching: boolean;
  sessionDuration?: number;
  sessionTimestamp?: number;
}

const CrashEventAttributes: FunctionComponent<Props> = ({
  attributes,
  crashTimestamp,
  isFetching,
  sessionDuration,
  sessionTimestamp,
}) => {
  const matchQuery = hooks.useMediaQuery(['700px', '1080px']);
  const { hasFeature } = useFeatures();

  const crashEvenAttribues = [
    { attribute: 'timestamp', title: 'Crash Time', value: crashTimestamp },
    { attribute: 'timestamp', title: 'Session Time', value: sessionTimestamp },
    ...(hasFeature('enable-easter-egg-hammer-time')
      ? [
          {
            attribute: 'timestamp',
            title: 'Hammer Time',
            children: (
              <Link href="https://youtu.be/otCpCn0l4Wo?t=14" target="HammerTime" textColor="gray-7">
                {formatterTimestamp('1990-05-31T23:00:00.000Z')}
              </Link>
            ),
          },
        ]
      : []),
    { attribute: 'duration', title: 'Session Duration', value: sessionDuration },
    ...ATTRIBUTES_CRASH_ORDER.map((attribute) => ({
      attribute,
      value: attributes && attributes[attribute],
    })),
  ];

  return (
    <Skeleton active={isFetching}>
      <Card padding="x8">
        <CardContent direction="vertical" gap="x4">
          <AttributeStatGrid
            attributes={crashEvenAttribues}
            attributesPerRow={matchQuery({ '700px': 2, '1080px': 1 }) || 1}
          />
        </CardContent>
      </Card>
    </Skeleton>
  );
};

export default CrashEventAttributes;
